import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Form, Card, Table } from 'react-bootstrap';
import NavLink from "react-bootstrap/NavLink";
import DashboardStat from "../../components/DashboardStat";
import { toast } from "react-toastify";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { GetDashboardData } from "../../services/dashboard.service";
import { GetUsers } from '../../services/users.service';
import UserCreationChart from '../../components/UserChart';
import UserAgeDemographics from '../../components/AgeChart';
import moment from 'moment';

function Dashboard() {
    let history = useHistory();
    const bottomDivRef = useRef(null);
    const [userCount, setUserCount] = useState(0);
    const [data, setData] = useState({})
    const [subscribeUserCount, setSubscribeUserCount] = useState(0);
    const [recordsCount, setRecordsCount] = useState(0);
    const [tasksCount, setTasksCount] = useState(0);
    const [lifeCatCount, setLifeCatCount] = useState(0);
    const [recordsByTypeCount, setRecordsByTypeCount] = useState({});
    const [cities, setCities] = useState([]);
    const [users, setUsers] = useState([]); // To hold user data for the chart
    const [loading, setLoading] = useState(false); // For managing loading state


    const { register, watch, handleSubmit, setError, clearErrors, formState: { errors } } = useForm({
        mode: "onBlur",
    });

    useEffect(() => {
        getDashboardData();
        getUsers(); // Fetch user data on load
    }, []);

    // Function to get dashboard data
    const getDashboardData = async () => {
        await GetDashboardData({ search: "daily" }, 0).then((result) => {
            if (result?.status) {
                if (result?.data) {
                    setUserCount(result?.data?.users);
                    setSubscribeUserCount(result?.data?.subscribed_users);
                    setRecordsCount(result?.data?.records);
                    setTasksCount(result?.data?.tasks);
                    setLifeCatCount(result?.data?.lifeCateories);
                    setRecordsByTypeCount(result?.data?.recordsByTypes);
                    setCities(result?.data?.cities);
                    setData(result.data);
                }
            } else {
                return toast.error(result.message);
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        });
    };

    // Function to get users data and pass to the chart
    const getUsers = async () => {
        setLoading(true);
        await GetUsers(false, '', '', '', 0) // Passing 0 as is_paginate value
            .then((result) => {
                if (result?.status && Array.isArray(result?.data)) { // Ensure 'data' is an array
                    const usersData = result.data.map((user, index) => ({
                        createdAt: user.createdAt,
                        ...user
                    }));
                    setUsers(usersData); // Set users data for chart
                } else {
                    setUsers([]); // Ensure it's an empty array if no data is returned
                }
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
                if (error.response?.status === 401) {
                    EmptyLocalStorage();
                    history.push('/');
                } else if (error.response?.status === 404) {
                    setUsers([]); // Ensure empty array in case of 404
                } else {
                    return toast.error(error.response?.data?.message || 'Something went wrong');
                }
            });
    };


    function handleClick() {
        bottomDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <div className='dashboard'>
            <Row className={"mt-3"}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 className="page-heading">Dashboard</h1>
                    <hr />
                </Col>
            </Row>
            <Row className={"mb-4 mt-2"}>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Total Registered Accounts"} countMain={userCount} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Total Subscribed Users"} countMain={subscribeUserCount} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Total Records"} countMain={recordsCount} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Total Tasks"} countMain={tasksCount} />
                    </Link>
                </Col>
            </Row>
            <Row className={"mt-3"}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 className="page-heading">Life Unlocked Entires</h1>
                    <hr />
                </Col>
            </Row>
            <Row className={"mb-4 mt-2"}>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Goals"} countMain={lifeCatCount.Goals} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Health"} countMain={lifeCatCount.Health} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Home"} countMain={lifeCatCount.Home} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Expiry"} countMain={lifeCatCount.Expiry} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Miscellaneous"} countMain={lifeCatCount.Misc} />
                    </Link>
                </Col>
            </Row>

            <Row className={"mt-3"}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 className="page-heading">Records</h1>
                    <hr />
                </Col>
            </Row>
            <Row className={"mb-4 mt-2"}>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"People"} countMain={recordsByTypeCount.PEOPLE} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Event"} countMain={recordsByTypeCount.EVENT} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Location"} countMain={recordsByTypeCount.LOCATION} />
                    </Link>
                </Col>
            </Row>

            <Row className={"mt-3"}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 className="page-heading">Entries</h1>
                    <hr />
                </Col>
            </Row>
            <Row className={"mb-4 mt-2"}>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Reviews"} countMain={data.reviews} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Planning"} countMain={data.plannings} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"History"} countMain={data.histories} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Brain Dump"} countMain={data.brainDumps} />
                    </Link>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className={"mb-4"}>
                    <Link to={"#"} className={"linkStats"}>
                        <DashboardStat title={"Gift Idea"} countMain={data.giftIdeas} />
                    </Link>
                </Col>
            </Row>

            {/* Display Cities with User Count */}
            <Row className={"mt-3"}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 className="page-heading">Top Cities by User Count</h1>
                    <hr />
                </Col>
            </Row>
            <Row className={"mb-4 mt-4"}>
                <Col xs={12}>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>City</th>
                                <th>User Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cities.map((city, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{city.name}</td>
                                    <td>{city.userCount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            {/* User Creation Chart */}
            <Row className={"mt-3"}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 className="page-heading">Users Demographics</h1>
                    <hr />
                </Col>
            </Row>
            <Row className={"mb-4 mt-2"}>
                <Col xs={12} sm={12} md={6} lg={6} xl={6} className={"mb-4"}>
                    <Card className={"p-3 shadow-sm"}>
                        {!loading && <UserCreationChart users={users} />}
                    </Card>

                    {/* <UserCreationChart users={users} /> */}
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6} className={"mb-4"}>
                    <Card className={"p-3 shadow-sm"}>
                        {!loading && <UserAgeDemographics users={users} />}
                    </Card>
                </Col>
            </Row>
            <Row>

            </Row>
        </div>
    );
}

export default Dashboard;
